/**
 * i18next configuration for internationalization
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation resources
import en from './locales/en.json';
import es from './locales/es.json';
// Member-facing pages only (TRUS-778): any key missing here falls back to English.
import vi from './locales/vi.json';
import zh from './locales/zh.json';
import tl from './locales/tl.json';

const resources = {
  en: {
    translation: en,
  },
  es: {
    translation: es,
  },
  vi: {
    translation: vi,
  },
  zh: {
    translation: zh,
  },
  tl: {
    translation: tl,
  },
};

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,

    interpolation: {
      escapeValue: false, // React already escapes by default
    },

    // Language detection options
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;
